import { render } from "./ClaimHome.vue?vue&type=template&id=620a848f&scoped=true"
import script from "./ClaimHome.vue?vue&type=script&lang=js"
export * from "./ClaimHome.vue?vue&type=script&lang=js"

import "./ClaimHome.vue?vue&type=style&index=0&id=620a848f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620a848f"]])

export default __exports__